/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { defineStore } from 'pinia';

import { BulkGrantRegisterForm } from '@/repositories/generated';
import { BulkGrantForm } from '@/validations';

type TBulkGrantState = {
  form?: BulkGrantForm;
  displayFileName: string;
  badRequestError?: {
    error: {
      code: string;
      message: string;
    };
  };
};

export const useBulkGrantStore = defineStore('bulkGrant', {
  state: (): TBulkGrantState => ({
    form: undefined,
    displayFileName: '',
    badRequestError: undefined,
  }),
  actions: {
    getBadRequestErrorAndDeleteStore() {
      const { badRequestError } = this;
      this.badRequestError = undefined;
      return badRequestError;
    },
    setForm(form: BulkGrantForm) {
      const { walletService } = form;
      this.form = {
        ...form,
        walletService: walletService && { ...walletService },
      };
    },
  },
  getters: {
    /** フォーム用のフォーマットからapi用のフォーマットに変換してSet */
    requestBody(): BulkGrantRegisterForm | undefined {
      return this.form && {
        name: this.form.name,
        systemName: this.form.systemName,
        accountType: this.form.accountType,
        expiredDatePattern: this.form.expiredDatePattern,
        expiredDateAddValue: this.form.expiredDateAddValue,
        specifiedMonth: this.form.specifiedMonth,
        fileName: this.form.fileName,
        fileType: this.form.fileType,
        remarks: this.form.remarks,
        // 変換するkey
        walletServiceId: this.form.walletService.id,
        grantScheduleDateTime: this.form.grantScheduleDateTime.toISOString(),
        grantSchedulePublishDateTime: this.form.grantSchedulePublishDateTime.toISOString(),
        specifiedDate: this.form.specifiedDate?.toISOString(),
      };
    },
  },
});
